import { Descriptions, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import {
  getEntranceDetail,
  getExamineeDetail,
  getExamSubjects,
  openEvaluation,
  updateStudentLevel,
} from '../../../../api/placeTest.api';
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import InputExamInfoModal from '../../../../components/modals/InputExamInfoModal';
import SelectExamScheduleModal from '../../../../components/modals/SelectExamScheduleModal';
import Button from '../../../../components/Button';
import useAxios from '../../../../hooks/useAxios';
import { getCommonCodeLabel } from '../../../../lib/store';
import {
  IExamineeDetail,
  IGetEntranceDetail,
  IGetExamineeDetail,
  IGetExamSubjects,
} from '../../../../models/placeTest.model';
import ErrorResponse from '../../../../components/ErrorResponse';
import Loader from '../../../../components/Loader';
import CancelExamModal from '../../../../components/entrance/schedule/examinee/detail/modals/CancelExamModal';
import moment from 'moment';
import styled from 'styled-components';
import ConfirmModal from '../../../../components/modals/ConfirmModal';
import useNotification from '../../../../hooks/useNotification';
import ShowSurveyModal from '../../../../components/entrance/schedule/examinee/detail/modals/ShowSurveyModal';
import { IGetOceanUrl } from '../../../../models/oceanTest.model';
import {
  getOceanResultUrl,
  getPredigerHistoryCode,
} from '../../../../api/oceanTest.api';
import AnswerModal from '../../../../components/modals/AnswerModal';
import { IGetSteps } from '../../../../models/courses.model';
import { getSteps } from '../../../../api/courses.api';
import AssignClassModal from '../../../../components/entrance/schedule/examinee/detail/modals/AssignClassModal';
import { IGetSpeakingResult } from '../../../../models/speaking2.model';
import { getSpeakingResult } from '../../../../api/speaking2.api';
import { addHyphen, getRank, getWebUrl } from '../../../../lib/util';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import useAuth from '../../../../hooks/useAuth';
import CounselorModal from '../../../../components/entrance/schedule/examinee/detail/modals/counselor/CounselorModal';
import QueryString from 'qs';

const Block = styled.div`
  .max-width-800 {
    max-width: 800px;
  }

  .ant-descriptions-item-content {
    padding-top: 1px !important;
    padding-bottom: 1px !important;
  }

  h2 {
    display: inline-block;
  }
`;

interface IMatch {
  platScheduleCode: string;
  platRequireCode: string;
}

const EntranceScheduleExamineeDetail = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const match = useRouteMatch<IMatch>();
  const platScheduleCode = Number(match.params.platScheduleCode);
  const platRequireCode = Number(match.params.platRequireCode);
  const { auth } = useSelector((state: RootState) => state.auth);
  const { successNotification } = useNotification();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetExamineeDetail>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetOceanUrl>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetExamSubjects>();
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetEntranceDetail>();
  const {
    data: res5,
    isLoading: isLoading5,
    error: error5,
    execute: execute5,
  } = useAxios<IGetSteps>();
  const {
    data: res6,
    isLoading: isLoading6,
    error: error6,
    execute: execute6,
  } = useAxios<IGetSpeakingResult>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();
  const {
    data: submitRes2,
    isLoading: submitIsLoading2,
    error: submitError2,
    execute: submitExecute2,
  } = useAxios();
  const {
    data: predigerResponse,
    isLoading: isPredigerLoading,
    error: predigerError,
    execute: predigerExecute,
  } = useAxios<any>();

  const [data, setData] = useState<IExamineeDetail>();
  const [steps, setSteps] = useState<any>();
  const [studentLevel, setStudentLevel] = useState<number>();
  const [eduStepCode, setEduStepCode] = useState('');
  const [inputExamInfoVisible, setInputExamInfoVisible] = useState(false);
  const [selectExamScheduleVisible, setSelectExamScheduleVisible] =
    useState(false);
  const [cancelExamVisible, setCancelExamVisible] = useState(false);
  const [confirmOpenVisible, setConfirmOpenVisible] = useState(false);
  const [showSurveyVisible, setShowSurveyVisible] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [examTestCode, setExamTestCode] = useState<number>();
  const [prtAnswerVisible, setPrtAnswerVisible] = useState(false);
  const [ptAnswerVisible, setPtAnswerVisible] = useState(false);
  const [assignClassVisible, setAssignClassVisible] = useState(false);
  //20240715 상담자 모달 관련 state추가
  const [counselorVisible, setCounselorVisible] = useState(false);

  useEffect(() => {
    if (platRequireCode) {
      doGetExamineeDetail(platRequireCode);
    }
  }, [platRequireCode]);

  useEffect(() => {
    if (platRequireCode) {
      doGetExamineeDetail(platRequireCode);
    }
  }, [counselorVisible]);

  useEffect(() => {
    doGetEntranceDetail();
  }, [platScheduleCode]);

  useEffect(() => {
    execute5(getSteps());
  }, []);

  useEffect(() => {
    if (res) {
      setData(res.data);
      const _examTestCode = res.data?.testInfo?.platExamTestCode;
      if (_examTestCode) {
        setExamTestCode(_examTestCode);
        execute3(getExamSubjects(_examTestCode));
        execute6(getSpeakingResult(_examTestCode));
      }

      if (
        res.data?.paymentInfo?.paymentSttCode === 'CA' ||
        res.data?.baseInfo?.cancelYn === 'Y'
      ) {
        setIsDisabled(true);
      }
    }
  }, [res]);

  useEffect(() => {
    if (res2) {
      window.open(
        `${res2?.data}&employeeMemberCode=${auth.memberCode}`,
        '_blank',
        'width=1200, height=768, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no',
      );
    }
  }, [res2]);

  useEffect(() => {
    if (res4?.data?.eduStepCode) {
      setEduStepCode(res4.data.eduStepCode);
    }
  }, [res4]);

  useEffect(() => {
    if (res5) {
      const newSteps: any = [];
      res5?.data?.forEach((level) => {
        level?.step?.forEach((step) => {
          newSteps.push({
            ...step,
            eduStepCode: level.eduStepCode,
          });
        });
      });
      setSteps(newSteps);
    }
  }, [res5]);

  useEffect(() => {
    if (submitRes) {
      console.log('asdasdasd');
      doGetExamineeDetail(platRequireCode);
      successNotification(t('common.message.save1'));
    }
  }, [submitRes]);

  useEffect(() => {
    if (submitRes2) {
      successNotification(t('common.message.save1'));
    }
  }, [submitRes2, platRequireCode]);

  useEffect(() => {
    window.addEventListener('message', receiveMessage, false);
    return () => window.removeEventListener('message', receiveMessage);
  }, []);

  useEffect(() => {
    const historyCode = predigerResponse?.data;
    if (historyCode && !isPredigerLoading) {
      const left = (window.screen.width - 1024) / 2;
      const top = (window.screen.height - 876) / 2;
      window.open(
        `${getWebUrl()}/prediger/${historyCode}`,
        `prediger/${historyCode}`,
        `width=1024, height=876, top=${top}, left=${left}, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no`,
      );
      return;
    }
  }, [predigerResponse, isPredigerLoading]);

  const receiveMessage = (e: any) => {
    if (e.data?.message === 'speaking-test-end') {
      execute6(getSpeakingResult(e.data.examTestCode));
    }
  };

  const doGetExamineeDetail = (platRequireCode: number) => {
    execute(getExamineeDetail(platRequireCode));
  };

  const doGetEntranceDetail = () => {
    if (platScheduleCode) {
      execute4(getEntranceDetail(platScheduleCode));
    }
  };

  const getReceiptAmount = () => {
    const price = Number(data?.paymentInfo?.price);
    const paymentCompleteAmount = Number(
      data?.paymentInfo?.paymentCompleteAmount,
    );

    switch (data?.paymentInfo?.paymentSttCode) {
      case 'WA':
        return `(${(price - paymentCompleteAmount).toLocaleString()} ${t(
          'entrance.schedule.text6',
        )})`;
      case 'PA':
      case 'CO':
        return `(${paymentCompleteAmount.toLocaleString()} ${t(
          'entrance.schedule.text6',
        )})`;
      default:
        return '';
    }
  };

  const onOpenEvaluation = () => {
    submitExecute(openEvaluation(platRequireCode));
    setConfirmOpenVisible(false);
  };

  const onOpenReportCard = () => {
    if (!examTestCode) return;

    window.open(
      `${getWebUrl()}/${
        eduStepCode === 'EM' ? '' : 'md-'
      }report-card?examTestCode=${examTestCode}`,
      '_blank',
      `width=${
        eduStepCode === 'EM' ? '990' : '1050'
      }, height=768, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=yes`,
    );
  };
  const onOpenOceanResultPopup = (oceanTestCode: number) => {
    execute2(getOceanResultUrl(oceanTestCode));
  };
  const onOpenPredigerResultPopup = (testNo: number) => {
    predigerExecute(getPredigerHistoryCode(testNo));
  };

  const onOpenSpeakingTest = () => {
    if (!examTestCode || !res4?.data?.studentInfo) return;

    const studentInfo = res4.data.studentInfo.find(
      (item) => item.placeTestCode === examTestCode,
    );
    if (studentInfo) {
      window.open(
        `/cbt/speaking-test/exam?placeTestCode=${
          studentInfo.placeTestCode
        }&speakingExamCode=${
          eduStepCode === 'EM'
            ? studentInfo.speakingExamCode
            : studentInfo.writingExamCode
        }&memberCode=${studentInfo.memberCode}&memberName=${
          studentInfo.memberName
        }&memberEngName=${studentInfo.memberEngName}&gradeCode=${
          studentInfo.gradeCode
        }`,
        '_blank',
      );
    }
  };

  const isSpeakingTestDisabled = () => {
    if (!examTestCode || !res4?.data?.studentInfo) {
      return true;
    }

    const studentInfo = res4.data.studentInfo.find(
      (item) => item.placeTestCode === examTestCode,
    );
    if (
      !studentInfo ||
      (eduStepCode === 'EM' && !studentInfo.speakingExamCode) ||
      (eduStepCode === 'MD' && !studentInfo.writingExamCode)
    ) {
      return true;
    }

    return false;
  };

  const onSubmitLevel = async () => {
    if (!studentLevel) return;

    await submitExecute2(
      updateStudentLevel(platRequireCode, {
        courseCode: studentLevel,
      }),
    );
    //20240826 레벨 등록되면 상담자 등록버튼 활성화를 위해 호출부분 추가
    if (platRequireCode) {
      await doGetExamineeDetail(platRequireCode);
    }
    //
  };

  const getSpeakingScore = (papers: any) => {
    const totalScore = papers.reduce(
      (acc: any, cur: any) => acc + cur.score,
      0,
    );
    const score = (totalScore / papers.length).toFixed(0);

    return `${getRank(Number(score), eduStepCode)} (${score})`;
  };

  return (
    <Block className="content scrollbar">
      {isLoading ||
      isLoading2 ||
      isLoading3 ||
      isLoading4 ||
      isLoading5 ||
      isLoading6 ||
      submitIsLoading ||
      submitIsLoading2 ? (
        <Loader />
      ) : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={error5} />
      <ErrorResponse error={error6} />
      <ErrorResponse error={submitError} />
      <ErrorResponse error={submitError2} />
      <SimpleHeader
        parentMenu={t('common.menu.placementTest')}
        currentMenu={t('entrance.schedule.title3')}
      />

      <div>
        <div className="comm-bx__between">
          <div className="comm-sch_result">
            <b>
              {t('entrance.schedule.title5')}{' '}
              {res?.data?.baseInfo?.cancelYn === 'Y'
                ? `${t('entrance.schedule.text7')}`
                : ''}
            </b>
          </div>
        </div>
        <div className="comm-table__area rowType">
          <Descriptions
            bordered
            column={2}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            <Descriptions.Item label={t('entrance.schedule.column23')}>
              {data?.baseInfo?.memberName} ({data?.baseInfo?.webId})
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column7')}>
              <div className="comm-btn__area">
                <span className="pt-2">
                  {data?.baseInfo?.openYn === 'Y'
                    ? t('entrance.schedule.column24')
                    : t('entrance.schedule.column25')}
                </span>
                {data?.baseInfo?.openYn === 'Y' ? null : (
                  <Button
                    className="btn-basic small mint"
                    onClick={() => setConfirmOpenVisible(true)}
                    text={t('entrance.schedule.column24')}
                    disabled={isDisabled}
                    writeAuthYn={writeAuthYn}
                  />
                )}
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column10')}>
              {data?.baseInfo?.schoolName} (
              {getCommonCodeLabel(
                'SY0006',
                data?.baseInfo?.gradeCode || '',
                'ko',
              )}
              )
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column26')}>
              {moment(data?.baseInfo?.examDate).format('YYYY.MM.DD')}{' '}
              {data?.baseInfo?.srtTime}
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column27')}>
              {data?.baseInfo?.parentName} ({data?.baseInfo?.parentWebId})
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column28')}>
              {addHyphen(data?.baseInfo?.parentMobilePhone)}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div className="comm-bx__between">
          <div className="comm-sch_result">
            <b>
              {t('entrance.schedule.title6')}
            </b>
          </div>
        </div>
        <div className="comm-table__area rowType">
          <Descriptions
            bordered
            column={2}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            <Descriptions.Item label={t('entrance.schedule.column29')}>
              {data?.paymentInfo?.price
                ? `${Number(data?.paymentInfo.price).toLocaleString()} ${t(
                    'entrance.schedule.text6',
                  )}`
                : '-'}
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column16')}>
              {getCommonCodeLabel(
                'PA0003',
                data?.paymentInfo?.paymentSttCode || '-',
                'ko',
              )}{' '}
              {getReceiptAmount()}
              {data?.paymentInfo?.paymentSttCode === 'WA' ||
              data?.paymentInfo?.paymentSttCode === 'PA' ? (
                <Button
                  className="btn btn-sm btn-secondary btn-w70p ml-2"
                  onClick={() =>
                    history.push(
                      `/student/student?memberCode=${data?.baseInfo?.memberCode}&campusCode=${data?.baseInfo?.campusCode}&tabIndex=3`,
                    )
                  }
                  text={t('entrance.schedule.button3')}
                />
              ) : null}
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column30')} span={2}>
              {data?.paymentInfo?.certifyCodeValue || '-'}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div className="comm-bx__between">
          <div className="comm-sch_result">
            <b>{t('entrance.schedule.title7')}</b>
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink-line"
              onClick={() => setInputExamInfoVisible(true)}
              text={t('entrance.schedule.button6')}
              disabled={isDisabled}
              writeAuthYn={writeAuthYn}
            />
            <Button
              className="btn-basic pink-line"
              onClick={() => setSelectExamScheduleVisible(true)}
              text={t('entrance.schedule.button7')}
              disabled={isDisabled}
              writeAuthYn={writeAuthYn}
            />
            <Button
              className="btn-basic gray"
              onClick={() => setCancelExamVisible(true)}
              text={t('common.button.cancel')}
              disabled={isDisabled}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className="comm-table__area rowType">
          <Descriptions
            bordered
            column={2}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            {eduStepCode === 'EM' ? (
              <>
                <Descriptions.Item label={t('entrance.schedule.column31')}>
                  {data?.testInfo?.surveyRequiredYn === 'Y'
                    ? data?.testInfo?.surveyCompleteYn === 'Y'
                      ? `${t('entrance.schedule.text8')} (${
                          data.testInfo.surveyScore
                        })`
                      : t('entrance.schedule.text9')
                    : t('entrance.schedule.text10')}
                </Descriptions.Item>
                <Descriptions.Item label="Pre Test">
                  {data?.testInfo?.prtRequiredYn === 'Y'
                    ? data?.testInfo?.prtCompleteYn === 'Y'
                      ? `${t('entrance.schedule.text8')} (${
                          data?.testInfo?.prtExamTypeName
                        } / ${data?.testInfo?.prtScore})`
                      : t('entrance.schedule.text9')
                    : t('entrance.schedule.text10')}
                </Descriptions.Item>
                <Descriptions.Item label="OCEAN">
                  {data?.testInfo?.oceanRequiredYn === 'Y'
                    ? data?.testInfo?.oceanCompleteYn === 'Y'
                      ? t('entrance.schedule.text8')
                      : t('entrance.schedule.text9')
                    : t('entrance.schedule.text10')}
                </Descriptions.Item>
              </>
            ) : (
              <Descriptions.Item label="Prediger">
                {data?.testInfo?.predigerRequiredYn === 'Y'
                  ? data?.testInfo?.predigerCompleteYn === 'Y'
                    ? t('entrance.schedule.text8')
                    : t('entrance.schedule.text9')
                  : t('entrance.schedule.text10')}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Placement Test">
              {data?.testInfo?.platCompleteYn === 'Y'
                ? `${data?.testInfo?.platExamTypeName} ${t(
                    'entrance.schedule.text8',
                  )} (${data?.testInfo?.platScore})`
                : t('entrance.schedule.text4')}
            </Descriptions.Item>
            <Descriptions.Item
              label={eduStepCode === 'EM' ? 'Speaking' : 'Writing'}
            >
              {res6?.data?.length
                ? t('entrance.schedule.text8')
                : t('entrance.schedule.text4')}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div className="comm-bx__between">
          <div className="comm-sch_result">
            <b>{t('entrance.schedule.title8')}</b>
          </div>
          <div className="comm-btn__area right">
            {eduStepCode === 'EM' && (
              <>
                <Button
                  className="btn-basic pink-line"
                  onClick={() => setShowSurveyVisible(true)}
                  text={t('entrance.schedule.button8')}
                  disabled={
                    isDisabled ||
                    (!data?.testInfo?.surveyScore &&
                      data?.testInfo?.surveyScore !== 0)
                  }
                />
                <Button
                  className="btn-basic pink-line"
                  onClick={() => setPrtAnswerVisible(true)}
                  text={t('entrance.schedule.button9')}
                  disabled={
                    isDisabled ||
                    !data?.testInfo?.prtExamCode ||
                    !data?.testInfo?.prtExamTestCode
                  }
                />
              </>
            )}
            <Button
              className="btn-basic pink-line"
              onClick={() => setPtAnswerVisible(true)}
              text={t('entrance.schedule.button10')}
              disabled={
                isDisabled ||
                !data?.testInfo?.platExamCode ||
                !data?.testInfo?.platExamTestCode
              }
            />
            <Button
              className="btn-basic pink-line"
              onClick={onOpenReportCard}
              text={t('entrance.schedule.button11')}
              disabled={
                isDisabled ||
                !examTestCode ||
                data?.testInfo?.platCompleteYn === 'N'
              }
            />
            <Button
              className="btn-basic pink-line"
              onClick={() => {
                if (data?.testInfo?.testNo) {
                  eduStepCode === 'EM'
                    ? onOpenOceanResultPopup(data.testInfo.testNo)
                    : onOpenPredigerResultPopup(data.testInfo.testNo);
                }
              }}
              text={
                eduStepCode === 'EM'
                  ? t('entrance.schedule.button12')
                  : t('entrance.schedule.9')
              }
              disabled={
                isDisabled ||
                (eduStepCode === 'EM' &&
                  data?.testInfo?.oceanCompleteYn !== 'Y') ||
                (eduStepCode === 'MD' &&
                  data?.testInfo?.predigerRequiredYn !== 'Y')
              }
            />
          </div>
        </div>
        <div className="comm-table__area rowType">
          <Descriptions
            bordered
            column={2}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            {res3?.data?.reportExamTestSubjectInfo?.map((item, index) => (
              <Descriptions.Item key={index} label={item.subjectName}>
                {item.myScore}/{item.totalScore} (
                {Math.round((item.myScore / item.totalScore) * 100)})
              </Descriptions.Item>
            ))}
          </Descriptions>
          {res3?.data?.reportExamTestSubjectInfo?.length ? null : (
            <table>
              <tbody>
                <tr>
                  <th>{t('entrance.schedule.text11')}</th>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="comm-bx__between">
          <div className="comm-sch_result">
            <b>{eduStepCode === 'EM' ? 'Speaking' : 'Writing'}</b>
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink-line"
              onClick={onOpenSpeakingTest}
              text={t('entrance.schedule.button13')}
              disabled={isDisabled || isSpeakingTestDisabled()}
            />
          </div>
        </div>
        <div className="comm-table__area rowType">
          <Descriptions
            bordered
            column={2}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            {res6?.data?.map((item, index) => (
              <Descriptions.Item key={index} label={item.partName}>
                {getSpeakingScore(item.papers)}
              </Descriptions.Item>
            ))}
          </Descriptions>
          {res6?.data?.length ? null : (
            <table>
              <tbody>
                <tr>
                  <th>{t('entrance.schedule.text11')}</th>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="comm-bx__between">
          <div className="comm-sch_result"><b>{t('entrance.schedule.title9')}</b></div>
        </div>
        <div className="comm-table__area rowType">
          <Descriptions
            bordered
            column={2}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            <Descriptions.Item label={t('entrance.schedule.column32')}>
              <div className="comm-btn__area">
                <Select
                  className="w-100p"
                  value={studentLevel || data?.levelInfo?.courseCode}
                  onChange={(value) => setStudentLevel(value)}
                >
                  {steps
                    ?.filter((item: any) => item.eduStepCode === eduStepCode)
                    ?.map((item: any) => (
                      <Select.Option
                        key={item.courseCode}
                        value={item.courseCode}
                      >
                        {item.courseName}
                      </Select.Option>
                    ))}
                </Select>
                <Button
                  className="btn-basic small pink-line"
                  onClick={onSubmitLevel}
                  text={t('common.button.edit')}
                  disabled={isDisabled || data?.baseInfo?.openYn === 'Y'}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column33')}>
              <div className="comm-btn__area">
                <span className="pt-2">
                  {data?.levelInfo?.className ||
                    `${t('entrance.schedule.text12')}`}
                </span>
                <Button
                  className="btn-basic pink small"
                  onClick={() => setAssignClassVisible(true)}
                  text={t('entrance.schedule.button2')}
                  disabled={isDisabled}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t('student.student.column35')}>
              <div className="comm-btn__area">
                <span className="pt-2">
                  {data?.levelInfo?.memberName ||
                    `${t('entrance.schedule.text12')}`}
                </span>
                <Button
                  className="btn-basic pink small"
                  onClick={() => setCounselorVisible(true)}
                  text={t('entrance.schedule.button2')}
                  // disabled={isDisabled}
                  disabled={data?.levelInfo ? false : true}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </Descriptions.Item>
          </Descriptions>
        </div>
        <div className="comm-bx__space">
          <div className="comm-btn__area">
            <Button
              className="btn-basic gray-line"
              onClick={() => {
                if(query.startDate && query.endDate) {
                  history.push(`/entrance/schedule/${platScheduleCode}/examinee?startDate=${query.startDate}&endDate=${query.endDate}`)
                } else {
                  history.push(`/entrance/schedule/${platScheduleCode}/examinee`)
                }
              }}
              text={t('common.button.back')}
            />
          </div>
        </div>
      </div>

      {inputExamInfoVisible && (
        <InputExamInfoModal
          visible={inputExamInfoVisible}
          setVisible={setInputExamInfoVisible}
          data={data}
          platScheduleCode={platScheduleCode}
          doGetExamineeDetail={doGetExamineeDetail}
          doGetEntranceDetail={doGetEntranceDetail}
        />
      )}
      {selectExamScheduleVisible && (
        <SelectExamScheduleModal
          visible={selectExamScheduleVisible}
          setVisible={setSelectExamScheduleVisible}
          campusCode={data?.baseInfo.campusCode}
          platRequireCode={data?.baseInfo.platRequireCode}
          doGetExamineeDetail={doGetExamineeDetail}
          defaultEduStepCode={eduStepCode}
          doGetEntranceDetail={doGetEntranceDetail}
        />
      )}
      {cancelExamVisible && (
        <CancelExamModal
          visible={cancelExamVisible}
          setVisible={setCancelExamVisible}
          data={data}
          doGetExamineeDetail={doGetExamineeDetail}
        />
      )}
      {confirmOpenVisible && (
        <ConfirmModal
          visible={confirmOpenVisible}
          setVisible={setConfirmOpenVisible}
          onConfirm={onOpenEvaluation}
          titleText={t('entrance.schedule.title11')}
          messageText={t('entrance.schedule.text16')}
          confirmText={t('common.option.yes')}
          cancelText={t('common.option.no')}
        />
      )}
      {showSurveyVisible && (
        <ShowSurveyModal
          visible={showSurveyVisible}
          setVisible={setShowSurveyVisible}
          platRequireCode={platRequireCode}
        />
      )}
      {prtAnswerVisible &&
        data?.testInfo?.prtExamCode &&
        data?.testInfo?.prtExamTestCode && (
          <AnswerModal
            examCode={data.testInfo.prtExamCode}
            examTestCode={data.testInfo.prtExamTestCode}
            visible={prtAnswerVisible}
            onCancel={() => {
              execute(getExamineeDetail(platRequireCode));
              setPrtAnswerVisible(false);
            }}
          />
        )}
      {ptAnswerVisible &&
        data?.testInfo?.platExamCode &&
        data?.testInfo?.platExamTestCode && (
          <AnswerModal
            examCode={data.testInfo.platExamCode}
            examTestCode={data.testInfo.platExamTestCode}
            visible={ptAnswerVisible}
            onCancel={() => {
              execute(getExamineeDetail(platRequireCode));
              execute3(getExamSubjects(data.testInfo.platExamTestCode));
              setPtAnswerVisible(false);
            }}
          />
        )}
      {assignClassVisible && (
        <AssignClassModal
          visible={assignClassVisible}
          setVisible={setAssignClassVisible}
          data={data}
          doGetExamineeDetail={doGetExamineeDetail}
          eduStepCode={eduStepCode}
        />
      )}
      {/*상담자 모달*/}
      {counselorVisible && (
        <CounselorModal
          visible={counselorVisible}
          setVisible={setCounselorVisible}
          platRequireCode={platRequireCode}
        />
      )}
    </Block>
  );
};

export default EntranceScheduleExamineeDetail;
